import {z} from 'zod';

import {FinancialProductPreferenceRefusalReasonSchema} from '../schemas/FinancialProductPreferenceRefusalReasonSchema';

/** Keep the adapter's authoritative response type, including its privacy and actor constraints. */
export const createFinancialProductPreferenceConflictResponseBodySchema = <
  CurrentSchema extends z.ZodType<unknown>,
>(
  currentSchema: CurrentSchema
) =>
  z.object({
    errors: z
      .array(z.object({code: FinancialProductPreferenceRefusalReasonSchema, message: z.string()}))
      .nonempty(),
    current: currentSchema,
  });
